import { ERouteDisclaimerMessage } from '../enums';
import { ValidatorState } from '../types';
import { countryAcceptSellingCoins } from '../utils';

export function sellingCoinsValidator(): ValidatorState {
  let disclaimersKeys: Array<string> = [];
  const isValid = countryAcceptSellingCoins();

  if (!isValid) {
    disclaimersKeys.push(ERouteDisclaimerMessage.SELLING_COINS_RESTRICTION);
  }

  return {
    isValid,
    disclaimersKeys
  };
}
